import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environments/environment';

/**
 * Guard to protect renewal flow routes based on feature flags.
 * Requires both digitalAssistant.enabled and digitalAssistant.renewals to be true.
 * Redirects to home if either flag is disabled.
 */
export const renewalFlowGuard: CanActivateFn = () => {
    const router = inject(Router);
    const enabled = environment.featureFlags?.digitalAssistant?.enabled ?? false;
    const renewals = environment.featureFlags?.digitalAssistant?.renewals ?? false;

    if (!enabled || !renewals) {
        router.navigate(['/']);
        return false;
    }

    return true;
};
